import { useNavigate } from "react-router-dom";
import { FaTrophy } from "react-icons/fa";

const HorizontalLayout = ({
  title,
  items,
  imageHeight = "100px",
  basePath,
}) => {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/${basePath}/${id}`);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-4">
      {/* Título */}
      <h1 className="text-lg font-bold text-gray-800 text-center">{title}</h1>

      {/* Grid de tarjetas */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {items.map((item, index) => (
          <div
            key={index}
            onClick={() => handleClick(item.id)}
            className="flex flex-col items-center p-4 rounded-2xl cursor-pointer transition transform hover:scale-[1.03] hover:shadow-lg bg-gradient-to-b from-yellow-400 via-yellow-500 to-yellow-600"
          >
            {/* Imagen o ícono */}
            <div className="w-full flex justify-center items-center bg-white rounded-xl shadow mb-3 p-2">
              {typeof item.imageSrc === "string" ? (
                <img
                  src={item.imageSrc}
                  alt={item.columnTitle}
                  style={{ height: imageHeight }}
                  className="object-contain rounded-md"
                />
              ) : (
                <div className="text-yellow-600 text-5xl">
                  {item.imageSrc || <FaTrophy />}
                </div>
              )}
            </div>

            {/* Info */}
            <div className="text-center w-full">
              <h2 className="text-sm font-bold text-white break-words whitespace-normal">
                {item.columnTitle}
              </h2>
              <p className="text-xs text-white opacity-90 mt-1 break-words whitespace-normal">
                {item.text1}
              </p>
              <p className="text-xs text-white opacity-90 break-words whitespace-normal">
                {item.text2}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalLayout;
